<template>
	<div>
		<Fontnavbar title="搜索"/>
		<van-search
			v-model="searchValue"
			show-action
			placeholder="请输入搜索关键词"
			@search="onSearch"
		>
			<div slot="action" @click="onSearch">搜索</div>
		</van-search>
    <div class="tip_text">
      提示：关键词搜索请加空格
    </div>
		<div class="goods-cate" v-if="cates.length > 0">
			<van-cell title="查询订单" icon="todo-list-o" />
			<div class="goods-cate-detail" style="display:flex">
				<div class="goods-cate-item" >
					<van-tag plain @click="goPage('/order/order')">单号查询</van-tag>
				</div>
				<div class="goods-cate-item" >		
					<van-tag plain @click="goPage('/order/order')">手机号查询</van-tag>
				</div>
				<div class="goods-cate-item" >
					<van-tag plain @click="goPage('/order/order')">收货人查询</van-tag>
				</div>
			</div>		
		</div>
		<div class="goods-cate" v-if="cates.length > 0">
			<van-cell title="店铺分类" icon="apps-o" />
			<div class="goods-cate-detail">
				<div class="goods-cate-item" v-for="(item,i) in cates" :key="i">
					<van-tag plain @click="goPage('/goods/index?cate_id='+item.id)">{{ item.cate_name }}</van-tag>
				</div>
			</div>		
		</div>
		
		<div class="goods-cate" v-if="brands.length > 0">
			<van-cell title="推广品牌" icon="label-o" />
			<div class="goods-cate-detail">
				<div class="goods-cate-item" v-for="(item,i) in brands" :key="i">
					<van-tag plain @click="goPage('/goods/index?brand_id='+item.id)">{{ item.brand_name }}</van-tag>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { searchPage } from '../../api.js'
import { post } from '../../request.js'
import Fontnavbar from "../../components/Navbar.vue";
import {
	Search,
	Cell,
	Tag,
	Toast
} from 'vant';

export default {
  components: {
		[Search.name]: Search,
		[Cell.name]: Cell,
		[Tag.name]: Tag,
		Fontnavbar
  },

  data() {
    return {
			searchValue: '',
			cates: [],
			brands: []
    };
  },
	
	mounted () {
		const that = this
		post(searchPage, {}).then((res) => {
			if (res.code == 200) {
				that.cates = res.data.cates
				that.brands = res.data.brands
			} else {
				Toast('网络错误');
			}
		})
	},

  methods: {
    onSearch() {
			if (this.searchValue) {
				this.$router.push({path: '/goods/index?keywords='+this.searchValue})
			} else {
				Toast('请输入关键字');
			}
    },
		
		goPage(path) {
			this.$router.push({path: path});
		},
  }
};
</script>

<style lang="less" scoped>
.tip_text{
  padding: 0 15px;
  margin-top: -10px;
  font-size: 12px;
  color: #969799;
  background-color: #ffffff;
}
.goods-cate{
	background-color: #ffffff;
}
.goods-cate-detail{
	padding:10px 15px;
}
.goods-cate-item{
	display: inline-block;
	margin: 0px 10px 10px 0px;
}
</style>
